import { MultiSelect } from 'libs/ui';
import { zones } from 'services/zones';

export const ZoneSelectMulti = (props) => {
  // zones
  const zonesItems = zones.getZones();

  // const options
  const options = zonesItems.map((el) => ({ label: el.name, value: el.zone_id }));

  return <MultiSelect {...props} options={options} />;
};
